import { encodeFolderPath, getFolderPathById, getFoldersMap } from '@opengov/bnp-component-folders/src';
import { useMemo } from 'react';
import { rootPath } from '../../../../../module/routes/paths';
import { convertFolders } from '../../components/ReportsFolders/ReportsFolders.utils';
import { useGetReportsFolders } from '../../components/ReportsFolders/hooks/useGetReportsFolders/useGetReportsFolders';

type UseFolderBreadcrumbsProps = {
  subdomain: string;
  entityId?: number;
  folderId?: string;
};

export const useFolderBreadcrumbs = ({ entityId, folderId, subdomain }: UseFolderBreadcrumbsProps) => {
  const { data: reportsFoldersData } = useGetReportsFolders({
    entityId,
    // Fetch folders if entityId present and a folderId is provided
    enabled: !!entityId && !!folderId
  });

  const { folders, foldersMap } = useMemo(() => {
    const folders = convertFolders(reportsFoldersData?.data || []);
    const foldersMap = getFoldersMap(folders);
    return { folders, foldersMap };
  }, [reportsFoldersData?.data]);

  const { folderBreadcrumb, parentFolders } = useMemo(() => {
    const folder = folderId ? foldersMap.get(folderId) : null;
    const folderAndAncestors = folderId ? getFolderPathById({ folders, folderId }) : null;
    const encodedFolderPath = folderAndAncestors ? encodeFolderPath(folderAndAncestors) : null;

    return {
      folderBreadcrumb: folder
        ? {
            hrefReactRouterVersion: encodedFolderPath
              ? folderPathReactRouterVersion(subdomain, encodedFolderPath)
              : undefined,
            href: encodedFolderPath ? folderPath(subdomain, encodedFolderPath) : undefined,
            title: folder.title
          }
        : null,
      // Can be enhanced later (say for dropdown with parent folders), check ActiveFolderBreadcrumbs.tsx
      parentFolders: folderAndAncestors?.slice(0, folderAndAncestors.length - 1) ?? []
    };
  }, [folderId, foldersMap, subdomain, folders]);

  return { folderBreadcrumb, parentFolders };
};

export function folderPathReactRouterVersion(entitySubdomain: string, encodedFolderPath: string) {
  return `/${entitySubdomain}/folders/${encodedFolderPath}`;
}

export function folderPath(entitySubdomain: string, encodedFolderPath: string) {
  return `${rootPath}${folderPathReactRouterVersion(entitySubdomain, encodedFolderPath)}`;
}
